import LegalPage from "@/components/site/LegalPage";

const sections = [
  {
    n: "1.0",
    title: "About MyAdventure-Passport",
    body: (
      <>
        <p className="mb-3">
          MyAdventure-Passport is a digital platform that enables users to:
        </p>
        <ul className="list-disc pl-6 space-y-1 mb-3">
          <li>Create and manage a digital camping passport.</li>
          <li>Check in at participating campsites.</li>
          <li>Collect digital campsite stamps.</li>
          <li>Track camping activities and achievements.</li>
          <li>Access premium features through paid subscriptions.</li>
        </ul>
        <p>
          MyAdventure-Passport does <strong>NOT</strong> provide campsite
          booking or reservation services.
        </p>
      </>
    ),
  },
  {
    n: "2.0",
    title: "User Eligibility",
    body: (
      <>
        <p className="mb-3">
          You must be at least 18 years old or have permission from a parent or
          legal guardian to use the Application.
        </p>
        <p>
          You are responsible for ensuring that the information provided during
          registration is accurate and up to date.
        </p>
      </>
    ),
  },
  {
    n: "3.0",
    title: "User Account",
    body: (
      <>
        <p className="mb-3">You are responsible for:</p>
        <ul className="list-disc pl-6 space-y-1 mb-3">
          <li>Maintaining the confidentiality of your account credentials.</li>
          <li>All activities performed under your account.</li>
          <li>Keeping your profile information accurate.</li>
        </ul>
        <p>
          You must immediately notify us if you suspect unauthorized access to
          your account.
        </p>
      </>
    ),
  },
  {
    n: "4.0",
    title: "Digital Check-ins and Passport Stamps",
    body: (
      <>
        <p className="mb-3">
          Digital campsite stamps are issued by participating campsite operators
          through approved verification methods.
        </p>
        <p className="mb-3">MyAdventure-Passport reserves the right to:</p>
        <ul className="list-disc pl-6 space-y-1 mb-3">
          <li>Reject fraudulent check-ins.</li>
          <li>Remove invalid or duplicate stamps.</li>
          <li>Suspend accounts found abusing the check-in system.</li>
        </ul>
        <p>
          Users must not attempt to manipulate GPS, QR codes, location data, or
          any verification process.
        </p>
      </>
    ),
  },
  {
    n: "5.0",
    title: "Premium Subscription",
    body: (
      <>
        <p className="mb-3">
          Certain features within the Application are available through paid
          subscriptions.
        </p>
        <p className="mb-3">
          Subscription benefits may vary depending on the selected plan.
        </p>
        <p className="mb-3">Subscription fees are displayed before purchase.</p>
        <p>
          Unless otherwise stated, subscriptions automatically renew according
          to the billing terms of the relevant app store unless cancelled before
          the renewal date.
        </p>
      </>
    ),
  },
  {
    n: "6.0",
    title: "Payments",
    body: (
      <>
        <p className="mb-3">
          Payments are processed through the relevant application marketplace or
          authorised payment providers.
        </p>
        <p className="mb-3">
          MyAdventure-Passport does not store your payment card information.
        </p>
        <p>
          All applicable taxes and charges are the responsibility of the user
          where required.
        </p>
      </>
    ),
  },
  {
    n: "7.0",
    title: "Refund Policy",
    body: (
      <>
        <p className="mb-3">
          All subscription payments and purchases of premium features are final.
        </p>
        <p className="mb-3">
          MyAdventure-Passport does not offer refunds except where required by
          applicable law or in cases of verified duplicate or unauthorized
          transactions.
        </p>
        <p>Please refer to our Refund Policy for additional information.</p>
      </>
    ),
  },
  {
    n: "8.0",
    title: "Campsite Information",
    body: (
      <>
        <p className="mb-3">
          MyAdventure-Passport provides information supplied by campsite
          operators.
        </p>
        <p className="mb-3">
          We do not guarantee the accuracy, availability, pricing, facilities,
          operating hours, or suitability of any campsite.
        </p>
        <p>
          Users should verify information directly with the campsite before
          visiting.
        </p>
      </>
    ),
  },
  {
    n: "9.0",
    title: "User Conduct",
    body: (
      <>
        <p className="mb-3">Users agree not to:</p>
        <ul className="list-disc pl-6 space-y-1">
          <li>Use false information.</li>
          <li>Share accounts with others.</li>
          <li>Attempt to gain unauthorized access to the system.</li>
          <li>Interfere with the Application or its services.</li>
          <li>Upload malicious software.</li>
          <li>Engage in fraudulent check-ins or stamp collection.</li>
          <li>Use the Application for unlawful purposes.</li>
        </ul>
      </>
    ),
  },
  {
    n: "10.0",
    title: "Intellectual Property",
    body: (
      <>
        <p className="mb-3">
          All content within the Application, including but not limited to:
        </p>
        <ul className="list-disc pl-6 space-y-1 mb-3">
          <li>Logos</li>
          <li>Software</li>
          <li>Graphics</li>
          <li>Icons</li>
          <li>Designs</li>
          <li>Text</li>
          <li>Digital stamps</li>
          <li>Trademarks</li>
        </ul>
        <p className="mb-3">
          remain the property of MyAdventure-Passport or their respective owners
          and are protected by applicable intellectual property laws.
        </p>
        <p>
          Users may not copy, reproduce, modify, distribute, or commercially
          exploit any part of the Application without prior written permission.
        </p>
      </>
    ),
  },
  {
    n: "11.0",
    title: "Privacy",
    body: (
      <>
        <p className="mb-3">
          Your use of the Application is also governed by our Privacy Policy.
        </p>
        <p>
          By using MyAdventure-Passport, you consent to the collection and
          processing of your information as described in the Privacy Policy.
        </p>
      </>
    ),
  },
  {
    n: "12.0",
    title: "Limitation of Liability",
    body: (
      <>
        <p className="mb-3">
          MyAdventure-Passport is provided on an "as is" and "as available"
          basis.
        </p>
        <p className="mb-3">
          To the maximum extent permitted by law, MyAdventure-Passport shall not
          be liable for:
        </p>
        <ul className="list-disc pl-6 space-y-1">
          <li>Loss of data.</li>
          <li>Loss of profits.</li>
          <li>Business interruption.</li>
          <li>Device damage.</li>
          <li>Service interruptions.</li>
          <li>Inaccurate campsite information.</li>
          <li>Actions or omissions of campsite operators.</li>
          <li>
            Any indirect, incidental, or consequential damages arising from the
            use of the Application.
          </li>
        </ul>
      </>
    ),
  },
  {
    n: "13.0",
    title: "Account Suspension or Termination",
    body: (
      <>
        <p className="mb-3">
          MyAdventure-Passport reserves the right to suspend or terminate
          accounts that:
        </p>
        <ul className="list-disc pl-6 space-y-1">
          <li>Violate these Terms.</li>
          <li>Engage in fraudulent activities.</li>
          <li>Abuse the platform.</li>
          <li>Threaten the security or integrity of the Application.</li>
        </ul>
      </>
    ),
  },
  {
    n: "14.0",
    title: "Updates to the Application",
    body: (
      <p>
        We may modify, update, improve, suspend, or discontinue any feature of
        the Application at any time without prior notice.
      </p>
    ),
  },
  {
    n: "15.0",
    title: "Changes to These Terms",
    body: (
      <>
        <p className="mb-3">
          We reserve the right to update these Terms from time to time.
        </p>
        <p className="mb-3">
          Updated Terms will become effective once published within the
          Application or on our official website.
        </p>
        <p>
          Continued use of the Application constitutes acceptance of the revised
          Terms.
        </p>
      </>
    ),
  },
  {
    n: "16.0",
    title: "Governing Law",
    body: (
      <>
        <p className="mb-3">
          These Terms shall be governed by and interpreted in accordance with
          the laws of Malaysia.
        </p>
        <p>
          Any disputes arising from or relating to these Terms shall be subject
          to the exclusive jurisdiction of the courts of Malaysia.
        </p>
      </>
    ),
  },
  {
    n: "17.0",
    title: "Contact Us",
    body: (
      <>
        <p className="mb-3">
          If you have any questions regarding these Terms &amp; Conditions,
          please contact us:
        </p>
        <p className="font-bold mb-1">MyAdventure-Passport Support</p>
        <p className="mb-1">Email: support@myadventure-passport.com</p>
        <p>Website: www.myadventure-passport.com</p>
      </>
    ),
  },
];

export default function Terms() {
  return (
    <LegalPage
      eyebrow="Terms & Conditions"
      title="Terms & Conditions"
      effective="1st July 2026"
    >
      <p className="mb-4">
        Welcome to MyAdventure-Passport. These Terms &amp; Conditions ("Terms")
        govern your access to and use of the MyAdventure-Passport mobile
        application ("Application", "App", "Service"). By creating an account
        or using the Application, you agree to be bound by these Terms.
      </p>
      <p className="mb-8">
        If you do not agree with these Terms, please do not use the Application.
      </p>

      {sections.map((s) => (
        <div key={s.n} className="mb-8">
          <h2 className="text-xl md:text-2xl font-extrabold mb-3" style={{ color: "var(--on-surface)" }}>
            <span style={{ color: "var(--premium)" }}>{s.n}</span> &nbsp; {s.title}
          </h2>
          <div style={{ color: "var(--on-surface)" }}>{s.body}</div>
        </div>
      ))}
    </LegalPage>
  );
}
